import { PARTNER_CRITERIA } from '@/constants/partner-criteria.js';

/**
 * Check whether an application meets a given partner's criteria.
 *
 * @param {string} partner - Partner key (e.g. 'skcp', 'gl', 'cmcr', 'lnie')
 * @param {Object} appData - The application data object
 * @returns {boolean}
 */
export function meetsPartnerCriteria(partner, appData) {
    const criteria = PARTNER_CRITERIA[partner];
    if (!criteria) {
        return true;
    }

    const province = appData.address?.province;
    if (!criteria.provinces.has(province)) {
        return false;
    }

    if (!criteria.incomeTypes.has(appData.income_type)) {
        return false;
    }

    if (criteria.creditSituations) {
        if (!appData.in_credit_situation || !criteria.creditSituations.has(appData.in_credit_situation)) {
            return false;
        }
    }

    if (criteria.maxRequestedAmount !== undefined) {
        const requestedAmount = appData.requested_amount ?? 0;
        if (requestedAmount > criteria.maxRequestedAmount) {
            return false;
        }
    }

    if (criteria.minTotalIncome !== undefined) {
        const totalIncome = (appData.monthly_income ?? 0) + (appData.monthly_other_income ?? 0);
        if (totalIncome < criteria.minTotalIncome) {
            return false;
        }
    }

    return true;
}
